module.exports = __webpack_public_path__ + "img/jo.c8cfe14d.svg";